module.exports = __webpack_public_path__ + "img/iconQuestionMark.6bb5c39b.svg";